import { render, staticRenderFns } from "./MiniCartItem.vue?vue&type=template&id=c7c31486"
import script from "./MiniCartItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniCartItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports